module.exports = __webpack_public_path__ + "static/img/index.6b2c45c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/device/D3000/index.png
// module id = t0j/
// module chunks = 0